import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Camera as UploadCameraIcon,
  ImageUp as UploadImageUpIcon,
  X as ModalCloseIcon,
} from "@mebi/ui";

interface UploadSourceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description: string;
  cameraLabel?: string;
  galleryLabel?: string;
  cameraInputId?: string;
  galleryInputId?: string;
  onCamera: () => void;
  onGallery: () => void;
  showRemove?: boolean;
  removeLabel?: string;
  onRemove?: () => void;
}

const UploadSourceModal: React.FC<UploadSourceModalProps> = ({
  open,
  onOpenChange,
  title = "Thêm tệp",
  description,
  cameraLabel = "Chụp ảnh mới",
  galleryLabel = "Chọn từ thư viện",
  cameraInputId,
  galleryInputId,
  onCamera,
  onGallery,
  showRemove = false,
  removeLabel = "Xóa tệp",
  onRemove,
}) => {
  const triggerClassName =
    "self-stretch h-9 p-2 bg-Color-Background-brand-default rounded-lg inline-flex justify-center items-center gap-2.5 cursor-pointer";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        className="!top-auto !bottom-0 !left-1/2 !translate-x-[-50%] !translate-y-0 !w-[calc(100vw-2rem)] sm:!w-96 !max-w-96 !p-0 !gap-0 !border-none !bg-transparent !rounded-none !shadow-none data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"
        aria-describedby="upload-source-modal-desc"
      >
        <div className="w-full px-6 py-4 bg-Color-Background-neutral-default_primary rounded-tl-2xl rounded-tr-2xl inline-flex flex-col justify-start items-start gap-4 overflow-hidden">
          <div className="self-stretch inline-flex justify-between items-center">
            <DialogTitle className="text-center justify-center text-black text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
              {title}
            </DialogTitle>
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="relative"
              aria-label="Đóng modal chọn nguồn tải lên"
            >
              <ModalCloseIcon className="w-6 h-6" />
            </button>
            <DialogDescription
              id="upload-source-modal-desc"
              className="sr-only"
            >
              {description}
            </DialogDescription>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            {cameraInputId ? (
              <label htmlFor={cameraInputId} className={triggerClassName}>
                <UploadCameraIcon className="w-6 h-6" />
                <span className="text-center justify-center text-Color-Text-neutral-white text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
                  {cameraLabel}
                </span>
              </label>
            ) : (
              <button
                type="button"
                className={triggerClassName}
                onClick={onCamera}
              >
                <UploadCameraIcon className="w-6 h-6" />
                <span className="text-center justify-center text-Color-Text-neutral-white text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
                  {cameraLabel}
                </span>
              </button>
            )}

            {galleryInputId ? (
              <label htmlFor={galleryInputId} className={triggerClassName}>
                <UploadImageUpIcon className="w-6 h-6" />
                <span className="text-center justify-center text-Color-Text-neutral-white text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
                  {galleryLabel}
                </span>
              </label>
            ) : (
              <button
                type="button"
                className={triggerClassName}
                onClick={onGallery}
              >
                <UploadImageUpIcon className="w-6 h-6" />
                <span className="text-center justify-center text-Color-Text-neutral-white text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
                  {galleryLabel}
                </span>
              </button>
            )}

            {showRemove && onRemove ? (
              <button
                type="button"
                className="self-stretch h-9 p-2 bg-Color-Background-negative-default rounded-lg inline-flex justify-center items-center gap-2.5"
                onClick={onRemove}
              >
                <span className="text-center justify-center text-Color-Text-neutral-white text-sm font-semibold font-['Be_Vietnam_Pro'] leading-5">
                  {removeLabel}
                </span>
              </button>
            ) : null}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UploadSourceModal;
